<script lang="ts" setup>
import MSvgIcon from '@libs/svg-icon/index.vue'
import type { NoticeReadOptions } from './types'
import type { Notice } from '@/api/system'
import { i18n } from '@/plugins/i18n'
import { JsonParse } from '@/utils/object-tools'
import store from '@/store'
import { loadStorage, saveStorage } from '@/utils/cache'
import { NOTICE_READ_STATUS } from '@/constant/cache-key'

const props = defineProps<{
  notice: Notice
}>()

const emits = defineEmits(['close'])
const { t } = i18n.global
const { user } = storeToRefs(store.authStore)

const url = computed(() => {
  return props?.notice?.url || import.meta.env.VITE_APP_STP_API
})

const contents = computed(() => {
  return (typeof props?.notice?.content === 'string' ? JsonParse(props?.notice?.content) : props?.notice?.content) || []
})

const mustRead = computed(() => {
  return props?.notice?.mustRead
})

// 唯一标识key
const cacheKey = computed(() => {
  return `${props?.notice?.id ?? ''}-${user.value.current_enterprise}-${user.value.user_id}`
})

function getReadNotices() {
  return loadStorage<Record<string, NoticeReadOptions>>(NOTICE_READ_STATUS, {})
}

// 跳转到详情页
// function handleGoIntro() {
//   if (!mustRead.value) {
//     handleUnderstand()
//     return
//   }
//   window.open(url.value, '_blank')
//   emits('close')
// }

// 确认已阅读
function handleUnderstand(jumpAble = true) {
  const readdNotices = getReadNotices()
  // 唯一标识
  readdNotices[cacheKey.value] = {
    read: true,
    confirmTime: new Date().getTime(),
  }
  saveStorage(NOTICE_READ_STATUS, readdNotices)
  if (jumpAble) {
    window.open(url.value, '_blank')
  }
  emits('close')
}
</script>

<template>
  <div class="py-10px  relative">
    <!-- <div v-if="!mustRead" class="w-5.5 h-5.5 absolute right-2.5 top-5 z-10 cursor-pointer" @click="handleUnderstand(false)">
      <MSvgIcon name="close" fill-class="w-5.5 h-5.5 text-[#979797]" />
    </div> -->

    <a-image class="mb-10px" src="https://rockbang.com.cn/uploads/20241225/081822_20241225-161729.png" fit="fill" width="620" height="304" />

    <div class="p-20px rounded-2xl bg-white">
      <div class="font-rubik font-500  text-16px leading-small mb-10px">
        {{ t('components.systemNotice.introductionToTheUpdateContent') }}
      </div>

      <div class="pl-10px mb-20px max-h-150px overflow-y-auto">
        <div v-for="(item, index) in contents" :key="index" class="mb-8px">
          <div class="font-500 text-14px leading-small text-[#4B5563] relative before:content-[''] before:block before:top-1/2 before:-translate-y-1/2 before:left--10px before:absolute before:w-5px before:h-5px before:rounded-50% before:bg-primary-600">
            {{ item.title }}
          </div>
          <div class="font-400 text-12px leading-small text-[#555]">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="flex justify-center space-x-2.5 mt-20px">
      <a-button type="primary" class=" rounded-full" @click="handleUnderstand(true)">
        <template #icon>
          <MSvgIcon name="view-detail" fill-class="w-5 h-5 text-white" />
        </template>
        <span>{{ t('components.systemNotice.learnTheDetails') }}</span>
      </a-button>
      <a-button v-if="!mustRead" @click="handleUnderstand(false)">
        <template #icon>
          <MSvgIcon name="commission-confirm" fill-class="w-5 h-5 text-primary-600" />
        </template>
        <span>{{ t('components.systemNotice.understand') }}</span>
      </a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
